import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-add-topic-dialog',
  templateUrl: './add-topic-dialog.component.html',
  styleUrls: ['./add-topic-dialog.component.scss']
})
export class AddTopicDialogComponent implements OnInit, OnDestroy, IDialogView, AfterViewInit {

  data: DialogModel;
  candidateSourceTypes: any[];
  ngUnsubscribe = new Subject<void>();

  constructor(private flowChartDataService: FlowChartDataService) {

  }

  ngOnInit() {
    this.flowChartDataService.getCandidateSourceTypes().pipe(takeUntil(this.ngUnsubscribe)).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.candidateSourceTypes = data.filter(o => o.toolName !== 'Project Settings'); // confirmed sajib vai
      }
      ,
      error => {
        console.error('flowchart get candidateSourceTypes error', error);
      }
    );
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy() {
  }

  onSelectCandidateSourceType() {
    let obj = this.data.input.selectedCandidateSourceType;
    this.data.input.name = obj.toolName + '/' + obj.sourceHeader;
    this.data.input.sectionType = this.data.input.selectedCandidateSourceType.sectionType;
  }

  onOkClicked(): boolean {
    if (!this.data.input.name || this.data.input.name.length === 0) {
      return false;
    }
    return true;
  }
}
